<template>
    <md-dialog :md-active.sync="show_current_order"
               :md-click-outside-to-close="false"
               :md-close-on-esc="false"
               @keydown.esc="updateIsShowing">
        <md-toolbar>
            <div class="md-title md-layout md-gutter md-alignment-center-center" style="width: inherit">
                <div class="md-layout-item">
                    Porting Order #{{ order.porting_order_number }}: {{ order.status }}
                </div>
                <div class="md-layout md-alignment-center-right">
                    <md-button class="md-primary md-layout-item md-size-15" @click="updateIsShowing"
                               :md-ripple="false">
                        <md-icon>close</md-icon>
                    </md-button>
                </div>
            </div>
        </md-toolbar>
        <md-dialog-content  v-loading="current_comments === null"
                            class="md-scrollbar"
                            style="padding-top: 20px">
            <el-collapse v-model="activeNames">
                <md-card>
                    <el-collapse-item name="order">
                        <template slot="title">
                            <md-card-header>
                                <div class="md-title">Order Details</div>
                            </md-card-header>
                        </template>
                        <md-card-content>
                            <md-table v-if="!user.is_staff">
                                <md-table-row>
                                    <md-table-cell class="cell-header">Order Number</md-table-cell>
                                    <md-table-cell style="text-align: center;" >{{ order.porting_order_number }}</md-table-cell>
                                    <md-table-cell class="cell-header">Name</md-table-cell>
                                    <md-table-cell style="text-align: center;">{{ order.name }}</md-table-cell>
                                </md-table-row>
                                <md-table-row>
                                    <md-table-cell class="cell-header">Old Network Service Provider</md-table-cell>
                                    <md-table-cell style="text-align: center;">{{ order.entity_id.name }}</md-table-cell>
                                    <md-table-cell class="cell-header">New Network Service Provider</md-table-cell>
                                    <md-table-cell style="text-align: center;">{{ order.new_entity }}</md-table-cell>
                                </md-table-row>
                                <md-table-row>
                                    <md-table-cell class="cell-header">Port Date</md-table-cell>
                                    <md-table-cell style="text-align: center;">{{ foc_date_formatter(order.foc_date) }}</md-table-cell>
                                    <md-table-cell class="cell-header">Status</md-table-cell>
                                    <md-table-cell style="text-align: center;">{{ order.status }}</md-table-cell>
                                </md-table-row>
                                <md-table-row>
                                    <md-table-cell class="cell-header">Date Created</md-table-cell>
                                    <md-table-cell style="text-align: center;">{{ created_date_formatter(order.date_created) }}</md-table-cell>
                                    <md-table-cell class="cell-header">Notification Email</md-table-cell>
                                    <md-table-cell style="text-align: center;">{{ order.port_status_notification_email }}</md-table-cell>
                                </md-table-row>
                            </md-table>

                            <md-table v-if="user.is_staff">
                                <md-table-row>
                                    <md-table-cell class="cell-header">Order Number</md-table-cell>
                                    <md-table-cell style="text-align: center;" >{{ order.porting_order_number }}</md-table-cell>
                                    <md-table-cell v-if="user.is_staff" class="cell-header">Requestor</md-table-cell>
                                    <md-table-cell v-if="user.is_staff" style="text-align: center;">{{ order.user_id.username }}</md-table-cell>
                                    <md-table-cell class="cell-header">Name</md-table-cell>
                                    <md-table-cell style="text-align: center;">{{ order.name }}</md-table-cell>
                                </md-table-row>
                                <md-table-row>
                                    <md-table-cell class="cell-header">Old Network Service Provider</md-table-cell>
                                    <md-table-cell style="text-align: center;">{{ order.entity_id.name }}</md-table-cell>
                                    <md-table-cell class="cell-header">New Network Service Provider</md-table-cell>
                                    <md-table-cell style="text-align: center;">{{ order.new_entity }}</md-table-cell>
                                    <md-table-cell class="cell-header">Status</md-table-cell>
                                    <md-table-cell style="text-align: center;">{{ order.status }}</md-table-cell>
                                </md-table-row>
                                <md-table-row>
                                    <md-table-cell class="cell-header">Port Date</md-table-cell>
                                    <md-table-cell style="text-align: center;">{{ foc_date_formatter(order.foc_date) }}</md-table-cell>
                                    <md-table-cell class="cell-header">Date Created</md-table-cell>
                                    <md-table-cell style="text-align: center;">{{ created_date_formatter(order.date_created) }}</md-table-cell>
                                    <md-table-cell class="cell-header">Notification Email</md-table-cell>
                                    <md-table-cell style="text-align: center;">{{ order.port_status_notification_email }}</md-table-cell>
                                </md-table-row>
                            </md-table>

                        </md-card-content>
                    </el-collapse-item>
                </md-card>
                <md-card
                         v-for="(current_comment, index) in current_comments"
                         :key="index" style="margin-top: 10px">
                    <el-collapse-item v-if="current_comment.request" :name="index">
                        <template slot="title">
                            <md-card-header>
                                <div class="md-title">
                                    Request Details #{{ current_comment.request.version }}: <div v-if="!old_format" :id="`status_${index}`" style="display: initial">{{ current_comment.status }}</div>
                                </div>
                                <p class="md-subhead">{{pr_date_formatter(current_comment.date_created)}}</p>
                            </md-card-header>
                        </template>

                        <md-card-content >
                            <md-table>
                                <md-table-row>
                                    <md-table-cell class="cell-header">Customer Name</md-table-cell>
                                    <md-table-cell style="text-align: center;" :id="`customer_name_${index}`">{{ current_comment.request.customer_name }}</md-table-cell>
                                    <md-table-cell class="cell-header">Billing Telephone Number</md-table-cell>
                                    <md-table-cell style="text-align: center;" :id="`billing_telephone_number_${index}`">{{ current_comment.request.billing_telephone_number }}</md-table-cell>
                                </md-table-row>
                                <md-table-row>

                                    <md-table-cell class="cell-header">Customer Street 1</md-table-cell>
                                    <md-table-cell style="text-align: center;" :id="`customer_street1_${index}`">{{ current_comment.request.customer_street1 }}</md-table-cell>
                                    <md-table-cell class="cell-header">Customer Street 2</md-table-cell>
                                    <md-table-cell style="text-align: center;" :id="`customer_street2_${index}`">{{ current_comment.request.customer_street2 }}</md-table-cell>
                                </md-table-row>
                                <md-table-row>
                                    <md-table-cell class="cell-header">Customer Country</md-table-cell>
                                    <md-table-cell style="text-align: center;" :id="`customer_country_${index}`">{{ current_comment.request.customer_country }}</md-table-cell>

                                    <md-table-cell class="cell-header">Customer City</md-table-cell>
                                    <md-table-cell style="text-align: center;" :id="`customer_city_${index}`">{{ current_comment.request.customer_city }}</md-table-cell>
                                </md-table-row>
                                <md-table-row>
                                    <!-- <md-table-cell class="cell-header">Customer Account Number</md-table-cell>
                                    <md-table-cell>{{ current_request.customer_account_number }}</md-table-cell> -->
                                    <md-table-cell class="cell-header">Customer Zip</md-table-cell>
                                    <md-table-cell style="text-align: center;" :id="`customer_zip_${index}`">{{ current_comment.request.customer_zip }}</md-table-cell>
                                    <md-table-cell class="cell-header">Customer State</md-table-cell>
                                    <md-table-cell style="text-align: center;" :id="`customer_state_${index}`">{{ current_comment.request.customer_state }}</md-table-cell>
                                </md-table-row>
                                <md-table-row>
                                    <md-table-cell class="cell-header">Attachments</md-table-cell>
                                    <md-table-cell style="text-align: center;" :id="`loa_uri_${index}`">
                                        <a rel="noopener noreferrer"
                                           target="_blank"
                                           :href="current_comment.request.loa_uri">{{ current_comment.request.loa_filename ||
                                            current_comment.request.loa_uri}}</a>
                                    </md-table-cell>
                                    <md-table-cell class="cell-header">Date Created</md-table-cell>
                                    <md-table-cell style="text-align: center;" :id="`date_created_${index}`">{{ date_formatter(current_comment.request, 'date_created') }}</md-table-cell>
                                </md-table-row>
                                <md-table-row>
                                    <md-table-cell class="cell-header">Ported Numbers</md-table-cell>
                                    <md-table-cell style="text-align: center;" :id="`phone_numbers_${index}`">{{ current_comment.request.phone_numbers }}</md-table-cell>
                                    <md-table-cell class="cell-header">Requested FOC date</md-table-cell>
                                    <md-table-cell style="text-align: center;" :id="`requested_foc_date_${index}`">{{ date_formatter(current_comment.request, 'requested_foc_date') }}</md-table-cell>

                                </md-table-row>
                            </md-table>
                            <div v-if="!old_format">
                                <md-divider/>
                                <el-card v-if="current_comment.text">
                                    <p class="cell-header">Comments</p>
                                    <p style="display: contents; font-weight: 500">{{ current_comment.text }}</p>
                                    <p class="md-subhead" >{{ current_comment.author }} commented at {{ pr_date_formatter(current_comment.date_created)}}</p>
                                </el-card>
                            </div>
                        </md-card-content>
                    </el-collapse-item>
                </md-card>

                <md-card style="margin-top: 10px"
                         v-if="old_format && order.comments">
                    <md-card-content>
                <span style="white-space: pre-line">{{ order.comments }}</span>
                    </md-card-content>
                </md-card>

                <md-card style="margin-top: 10px"
                         v-if="current_comments && current_comments.length > 0 && !old_format">
                    <el-collapse-item name="comments">
                        <template slot="title">
                            <md-card-header>
                                <div class="md-title">Comments</div>
                            </md-card-header>
                        </template>

                        <md-card-content>
                            <el-timeline
                                    :reverse=false
                                    style="padding-inline-start: initial;">
                                <el-timeline-item
                                    style="padding-bottom: 0"
                                    v-for="(comment, index) in current_comments"
                                    :key="index"
                                    placement="top"
                                    :color="getColor(comment.comment_type)"
                                    :timestamp="pr_date_formatter(comment.date_created)">
                                    <p><b>Status:
                                    </b>{{comment.status}}
                                    </p>
                                    <p style="line-height: 10px"><b>{{comment.author}}:
                                    </b>{{comment.text}}
                                    </p>
                                    <div style="color: #545c64; line-height: initial; margin-left: 20px">
                                        <div v-for="(system_comment, index) in comment.system_comments"
                                             style=""
                                             :key="index">
                                            <p>
                                            <b>System:
                                            </b>{{system_comment.text}} (<i style="font-weight: 600">{{system_comment.recipient}}</i>)
                                            </p>
                                        </div>
                                    </div>
                                </el-timeline-item>
                            </el-timeline>
                        </md-card-content>
                    </el-collapse-item>
                </md-card>
            </el-collapse>
        </md-dialog-content>
    </md-dialog>
</template>

<script>
    import {mapState} from "vuex";
    import moment from "moment";
    import {
        COMMENTS_COLORS
    } from '../utils/constants';

    export default {
        name: "OrderItemView",
        props: ['order', 'show_current_order'],
        data() {
            return {
                show: this.show_current_order,
                activeNames: ['order', 0, 'comments'],
            }
        },

        watch: {
            show_current_order: function (newVal, oldVal) {
                if (oldVal === false && newVal === true) {
                    //this.$store.dispatch('orders/getRequests', {porting_order_id: this.order.id})
                    this.$store.dispatch('orders/getComments', {porting_order: this.order.id})
                } else {
                    //this.$store.dispatch('orders/setCurrentRequests', [])
                    this.$store.dispatch('orders/setCurrentComments', null)
                }
            },
            current_comments: function () {
                if (!this.show_current_order) return;
                this.$nextTick (function () {

                if (this.current_comments.length > 1) {
                    this.highlightDifference();
                }})
            }
        },
        methods: {
            updateIsShowing: function () {
                this.$emit('update:show_current_order', !this.show_current_order)
            },
            tableHeaderStyle({rowIndex}) {
                if (rowIndex === 0) {
                    return 'background-color: #f4f4f4;color: #475669'
                }
            },
            getColor(comment_type) {
                return COMMENTS_COLORS[comment_type]
            },
            getComment(request) {
                let comment = this.current_comments.filter(function (comment) {
                    return comment.request.id === request.id
                })
                return (comment && comment.length > 0) ? comment[0] : null;
            },
            getStatus(request) {
                let status_comment = this.current_comments.filter(function (comment) {
                    return comment.request.id === request.id
                })
                return (status_comment && status_comment.length > 0) ? status_comment[0].status : "";
            },
            highlightDifference() {
                if (this.current_comments.length < 2)
                    return;

                this.current_comments.forEach(function(item, i, arr) {
                    item = { ...item['request'] }
                    item['status'] = arr[i].status
                    let j = i + 1
                    while (j < arr.length && !arr[j]['request'])
                        j += 1
                    if (j < arr.length) {
                        let next_item = arr[j]['request']
                        next_item['status'] = arr[j]['status']
                        const exclusions = ['id', 'version', 'date_created', 'porting_order_id', 'customer_account_number']
                        for (const [key, value] of Object.entries(item)) {
                            if (!exclusions.includes(key) && value !== next_item[key]) {
                                if ((!value && next_item[key] === "") || (!next_item[key] && value === "")) continue
                                let elem = document.querySelector(`#${key}_${i}`)
                                if (elem)
                                    elem.style.backgroundColor = '#fff25e'
                            }
                        }
                    }
                });
            },
            pr_date_formatter(date){
                return moment(date).format('YYYY-MM-DD hh:mm:ss')
            },
            foc_date_formatter(row) {
                return row ? moment(row).format('YYYY-MM-DD') : '';
            },
            created_date_formatter(row) {
                let date_created = (row && !row.date_created) ? row : row.date_created;
                return moment(date_created).format('YYYY-MM-DD');
            },
            date_formatter(row, field) {
                return moment(row[field]).format('YYYY-MM-DD');
            },
        },
        computed: {
            ...mapState({
                //current_requests: state => state.orders.current_requests,
                current_comments: state => state.orders.current_comments,
                old_format: state => state.orders.old_format,
                user: state => state.auth.user
            }),
            //current_comments: {
            //    get() {
                    //if (this.$store.state.orders.current_comments.length > 0) {
                    //    return (this.user.is_staff) ? this.$store.state.orders.current_requests : [this.$store.state.orders.current_requests[0]];
            //        }
            //        return [];
            //    },
            //},
        },
    }
</script>

<style scoped>
    .md-dialog {
        min-width: 70%;
        max-width: 95%;
    }

    .md-dialog /deep/ .md-dialog-container {
        transform: none;
    }

    .md-card-content:last-of-type {
        padding-bottom: 16px !important;
    }

    .cell-header {
        color: rgb(71, 86, 105);
        width: 250px;
    }

</style>

<style>
    .el-collapse-item__content {
        padding-bottom: 0 !important;
    }
    .el-collapse-item__header {
        height: 70px !important;
    }
</style>

